import { createSelector } from 'reselect';

const adminRootSelector = (state: TReduxState) => state.root.admin;
const adminUsersManagementSelector = createSelector(adminRootSelector, (state) => state.usersManagement)

export const selectAdminUsers = createSelector(adminUsersManagementSelector, (state) => state.users)